import { createAction, props } from '@ngrx/store';
import { FeatureKey } from '@fc-core/feature-flags/feature.model';

export const loadFeatures = createAction('[Features] Load Features');

export const loadFeaturesSuccess = createAction(
  '[Features] Load Features Success',
  props<{ payload: FeatureKey[] }>(),
);

export const loadFeaturesError = createAction(
  '[Features] Load Features Error',
  props<{ err: any }>(),
);
